import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingIndicatorService } from '../../services/shared/loading-indicator.service';

export const loadingIndicatorInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingIndicatorService);

  const excludedPatterns = [
    /\/v1\/[^\/]+\/users\/\d+\/conversations/,
    /\/notifications\/\d+/,
    // /\/provider\/chat/,
  ];
  const excludedStaticUrls = [
    '/users/chatjwt',
    '/provider/chat',
    '/provider/case-files',
  ];

  if (
    excludedPatterns.some((pattern) => pattern.test(req.url)) ||
    excludedStaticUrls.some((url) => req.url.includes(url))
  ) {
    return next(req);
  }
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    })
  );
};
